import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { Profil, Organization } from "src/redux/user";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

interface Props {
  profil: Profil;
  organization: Organization;
  updateUserProfil: (profil: Profil) => void;
}
type PropsWithNamespaces = Props & WithNamespaces;
interface State {
  firstName: string;
  lastName: string;
  phone: string;
  mobile: string;
  email: string;
}
class UserInfos extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    firstName: this.props.profil.firstname,
    lastName: this.props.profil.lastname,
    phone: this.props.profil.phone,
    mobile: this.props.profil.mobile,
    email: this.props.profil.email
  };
  onChangeFirstName = e => {
    this.setState({
      firstName: e.target.value
    });
  };
  onChangelastName = e => {
    this.setState({
      lastName: e.target.value
    });
  };
  onChangePhone = e => {
    this.setState({
      phone: e.target.value
    });
  };
  onChangeMobile = e => {
    this.setState({
      mobile: e.target.value
    });
  };
  onChangeMail = e => {
    this.setState({
      email: e.target.value
    });
  };
  submit = async e => {
    e.preventDefault();

    const profil: Profil = {
      firstname: this.state.firstName,
      lastname: this.state.lastName,
      phone: this.state.phone,
      mobile: this.state.mobile,
      email: this.state.email,
      id: this.props.profil.id
    };
    try {
      await this.props.updateUserProfil(profil);
      toast.success(this.props.t("user.infos.success"));
    } catch {
      toast.error(this.props.t("error.unknown"));
    }
  };
  render() {
    return (
      <div className="custom-form profil">
        <div className="d-flex flex-column flex-lg-row">
          <div className="flex-1">
            <h2 className="mb-3">{this.props.t("user.infos.profil.title")}</h2>
            <p>{this.props.t("user.infos.profil.firstName")}</p>
            <div className="group">
              <input
                value={this.state.firstName}
                placeholder={this.props.t("user.infos.profil.firstName")}
                onChange={e => this.onChangeFirstName(e)}
              />
              <span className="highlight" />
              <span className="bar" />
              <label />
            </div>
            <p>{this.props.t("user.infos.profil.lastName")}</p>
            <div className="group">
              <input
                value={this.state.lastName}
                placeholder={this.props.t("user.infos.profil.lastName")}
                onChange={e => this.onChangelastName(e)}
              />
              <span className="highlight" />
              <span className="bar" />
              <label />
            </div>
            <p>{this.props.t("user.infos.profil.phone")}</p>
            <div className="group">
              <input
                placeholder={this.props.t("user.infos.profil.phone")}
                value={this.state.phone}
                onChange={e => this.onChangePhone(e)}
              />
              <span className="highlight" />
              <span className="bar" />
              <label />
            </div>
            <p>{this.props.t("user.infos.profil.mobile")}</p>
            <div className="group">
              <input
                placeholder={this.props.t("user.infos.profil.mobile")}
                value={this.state.mobile}
                onChange={e => this.onChangeMobile(e)}
              />
              <span className="highlight" />
              <span className="bar" />
              <label />
            </div>
            <p>{this.props.t("user.infos.profil.mail")}</p>
            <div className="group">
              <input
                placeholder={this.props.t("user.infos.profil.mail")}
                value={this.state.email}
                onChange={e => this.onChangeMail(e)}
              />
              <span className="highlight" />
              <span className="bar" />
              <label />
            </div>
          </div>
          <div className="flex-1">
            <h2 className="mb-3">
              {this.props.t("user.infos.organization.title")}
            </h2>
            <p className="mb-1">{this.props.organization.name}</p>
            <p className="mb-1">{this.props.organization.adress}</p>
            <p>
              {this.props.organization.zipCode} {this.props.organization.city}
            </p>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <div>
            <button
              onClick={e => this.submit(e)}
              className="btn btn-primary mr-1"
            >
              {this.props.t("user.infos.buttons.profil")}
            </button>
          </div>
          <div>
            <Link
              className="btn btn-primary d-flex align-items-center"
              to="account"
            >
              {this.props.t("user.infos.buttons.account")}
              <img
                className="ml-1"
                src="assets/svgs/right-chevron-white.svg"
                width="10px"
              />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
export default withNamespaces()(UserInfos);



// WEBPACK FOOTER //
// ./src/components/UserInfos.tsx